module["exports"] = [
  "Sig.",
  "Dott.",
  "Dr.",
  "Ing."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/name/prefix.js
// module id = 1455
// module chunks = 1